import React from "react";
import PropTypes from "prop-types";

import ClipboardCopy from "@components/common/clipboard_copy/main";
import sanitize from "@helpers/sanitize";
import CustomFieldsAccordion from "./customFieldsAccordion";
import AssetTags from "./assetTags";

/* NOTE : Anytime you do work in this component make sure there is parody within
the orgSearchResultsAssetDetails component. At some point these should become one
component. Right now they are separated because this component is getting the majority
of it's information from rails, whereas the orgSearchResultsAssetDetails is
getting it's information from an ajax call, which at this point is not sufficient
to receive the information and do all the actions we need */

class TextDetails extends React.Component {
  get brandfolder() {
    return BF.fx.brandfolder();
  }

  get collection() {
    return BF.fx.collection();
  }

  renderUpdatedCreated() {
    const { updatedAndCreated } = this.props;
    if (typeof updatedAndCreated === "string") {
      return (
        <div
          dangerouslySetInnerHTML={{ __html: sanitize(updatedAndCreated) }}
        />
      );
    }
    return updatedAndCreated;
  }

  render() {
    const {
      approvedBy,
      asset,
      awaitingApproval,
      collectionExpiration,
      customFields,
      expired,
      expirationDate,
      formattedDescription,
      orgSearchPage,
      publishDate,
      tags,
      unpublished,
      updatedAndCreated
    } = this.props;

    const descriptionMissing = asset.attributes
      ? !asset.attributes.description
      : !asset.description;

    return (
      <React.Fragment>
        {orgSearchPage || descriptionMissing ? (
          " "
        ) : (
          <ClipboardCopy
            textToCopy={
              asset.attributes
                ? asset.attributes.description.replace(/(<([^>]+)>)/gi, "")
                : asset.description.replace(/(<([^>]+)>)/gi, "")
            }
            check
            showFeedbackAsTooltip={false}
          >
            <span className="bff-copy" />
            &nbsp; {t("Copy to clipboard")}
          </ClipboardCopy>
        )}
        {orgSearchPage || descriptionMissing ? (
          " "
        ) : (
          <ClipboardCopy
            textToCopy={
              asset.attributes
                ? asset.attributes.description
                : asset.description
            }
            check
            showFeedbackAsTooltip={false}
          >
            <span className="bff-copy" />
            &nbsp; {t("Copy to clipboard (with formatting)")}
          </ClipboardCopy>
        )}
        {formattedDescription ? (
          <div className="m-show-description s-asset-description">
            <p
              dangerouslySetInnerHTML={{
                __html: this.props.formattedDescription.replace(/\n/g, "<br>")
              }}
            />
          </div>
        ) : (
          ""
        )}

        {updatedAndCreated ? this.renderUpdatedCreated() : ""}

        {approvedBy ? (
          <div dangerouslySetInnerHTML={{ __html: approvedBy }} />
        ) : (
          ""
        )}
        {awaitingApproval ? (
          <div dangerouslySetInnerHTML={{ __html: awaitingApproval }} />
        ) : (
          ""
        )}
        {collectionExpiration ? (
          <div dangerouslySetInnerHTML={{ __html: collectionExpiration }} />
        ) : (
          ""
        )}

        {publishDate ? (
          <div className="s-modal-published-on">
            {`${
              unpublished ? t("Will Publish on") : t("Published on")
            } ${publishDate}`}
          </div>
        ) : (
          ""
        )}

        {expirationDate ? (
          <div className="s-modal-expires-on">
            {`${expired ? t("Expired on") : t("Expires on")} ${expirationDate}`}
          </div>
        ) : (
          ""
        )}

        {tags.length > 0 ? (
          <AssetTags tags={tags} orgSearchPage={orgSearchPage} />
        ) : (
          ""
        )}

        {customFields && Object.keys(customFields).length > 0 ? (
          <CustomFieldsAccordion count={6} customFields={customFields} />
        ) : (
          ""
        )}
      </React.Fragment>
    );
  }
}

TextDetails.propTypes = {
  approvedBy: PropTypes.string,
  asset: PropTypes.shape({}).isRequired,
  awaitingApproval: PropTypes.string,
  collectionExpiration: PropTypes.string,
  customFields: PropTypes.shape({}).isRequired,
  expirationDate: PropTypes.string,
  expired: PropTypes.bool,
  formattedDescription: PropTypes.string,
  orgSearchPage: PropTypes.bool,
  publishDate: PropTypes.string,
  tags: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  unpublished: PropTypes.bool,
  updatedAndCreated: PropTypes.string.isRequired
};

TextDetails.defaultProps = {
  approvedBy: "",
  awaitingApproval: "",
  collectionExpiration: "",
  expirationDate: "",
  expired: true,
  formattedDescription: "",
  orgSearchPage: false,
  publishDate: "",
  unpublished: true
};

export default TextDetails;
